import { render, staticRenderFns } from "./fileMetaModal.vue?vue&type=template&id=063e942e&scoped=true&"
import script from "./fileMetaModal.vue?vue&type=script&lang=js&"
export * from "./fileMetaModal.vue?vue&type=script&lang=js&"
import style0 from "./fileMetaModal.vue?vue&type=style&index=0&id=063e942e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e942e",
  null
  
)

export default component.exports